import { render } from "./MostPopular.vue?vue&type=template&id=15e3e9d2&ts=true"
import script from "./MostPopular.vue?vue&type=script&lang=ts"
export * from "./MostPopular.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__